import TextareaAutosize from 'react-textarea-autosize';

type Props = {
  autoFocus?: boolean;
  body: string;
  ariaLabel: string;
  placeholder?: string;
  onChange(body: string): void;
  onSubmit(): void;
  onFocus?(): void;
  minRows?: number;
};

export const ModelCommentBodyForm: React.FC<Props> = ({
  autoFocus,
  body,
  ariaLabel,
  placeholder,
  onChange,
  onSubmit,
  onFocus,
  minRows,
}: Props) => {
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = event.target.value;
    onChange(value);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    const withMetaKey = event.ctrlKey || event.metaKey;
    if (event.key == 'Enter' && withMetaKey) {
      onSubmit();
    }
  };

  return (
    <div className="w-full text-3xl [&>textarea:focus]:border-brand [&>textarea]:w-full [&>textarea]:rounded-lg [&>textarea]:border-2 [&>textarea]:border-gray-400 [&>textarea]:bg-gray-100 [&>textarea]:p-2 [&>textarea]:outline-none [&>textarea]:placeholder:text-gray-600">
      <TextareaAutosize
        autoFocus={autoFocus}
        minRows={minRows}
        value={body}
        aria-label={ariaLabel}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onFocus={onFocus}
        placeholder={placeholder}
      />
    </div>
  );
};
